<!--
 * @Descripttion:
 * @Author: 李子和
 * @Date: 2019-12-03 14:30:16
 -->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: "微软雅黑", Helvetica, Arial, sans-serif;
  text-align: center;
  color: #333;
  min-height: 100%;
  height: 100%;
  /* background-color: #f9f9f9 */
}
</style>



// WEBPACK FOOTER //
// src/App.vue